import sortBy from 'lodash/sortBy';
import { levenshteinDistance } from '../../../../util/levenshteinDistance';
import { FilterChoice } from '../../types/FilterChoice';

export const sortFiltersByRelevance = (rawFilters: FilterChoice[], searchTerm: string) => {
  const searchTermParts = searchTerm.toLowerCase().split(' in ');
  const likelyTopic = searchTermParts[0] ?? '';
  const likelyLocation = searchTermParts[0] ?? searchTermParts[1] ?? '';

  const topicCounts = rawFilters.reduce<Record<string, number>>((counts, filter) => {
    const topic = filter.topic?.specialist ?? filter.topic?.treatment ?? '';
    counts[topic] = (counts[topic] ?? 0) + 1;
    return counts;
  }, {});

  const sortedFilters = sortBy(
    rawFilters,
    it =>
      shortestWordDistance(
        likelyTopic,
        (it.topic?.specialist ?? it.topic?.treatment ?? '').toLowerCase(),
      ) + shortestWordDistance(likelyLocation, it.location?.suburb?.name?.toLowerCase() ?? ''),
    it => -(topicCounts[it.topic?.specialist ?? it.topic?.treatment ?? ''] ?? 0),
  );

  return sortedFilters;
};

const shortestWordDistance = (phrase: string, word: string) => {
  const result = Math.min(
    ...phrase.split(/\s+/).map(it => {
      if (word.startsWith(it)) return 0;
      return levenshteinDistance(it, word);
    }),
  );

  return result;
};
